import { releaseStepsToStepRunGraph } from './../helpers/demoHelpers';
import { AppPlatform, Release } from '../types';
import { RecursiveStringifyEnums } from './buildDistro';
import { baseReleaseStepsForPlatform } from '@/testData/releaseSteps';

export const upcomingReleaseMock: (platform: AppPlatform) => RecursiveStringifyEnums<Release> = (platform) => ({
    appStoreAvailableBuilds: [],
    appStoreReviewData: {
        averageRating: 4.37618,
        recentReviews: [],
        totalRatingsCount: 739,
        viewAllReviewsUrl: 'https://apps.apple.com/us/app/id595068606#see-all/reviews',
        issues: [],
    },
    workflowRunId: null,
    phasedReleaseHasBeenSupersededByNewRelease: false,
    appStoreSelectedBuilds: [],
    createdAt: '2023-06-21T19:48:48.608524368Z',
    createdOrigin: 'draft',
    devRejectedOn: null,
    reviewSubmissionWithoutAppVersion: false,
    featureFlags: [],
    displayableNextVersion: '1.2.0',
    displayableVersion: '1.2.0',
    doesBranchExist: false,
    isStaticReleaseBranch: false,
    id: 'appollo-ios:1.2.0',
    isKickedOff: false,
    isReleaseTagged: false,
    isReleased: false,
    isSubmitted: false,
    canBeSubmitted: true,
    kickedOffAt: null,
    latestStagingBuild: null,
    latestSuccessfulBuild: null,
    latestSuccessfulProdBuild: null,
    latestWorkingBranchBuild: null,
    nextVersion: '3.106.0',
    overview: {
        averageAppStoreCrashFreeSessions: 0,
        averageAppStoreCrashFreeUsers: 0,
        averageBetaCrashFreeSessions: 100,
        averageBetaCrashFreeUsers: 100,
        codeContributors: [],
        contributingTeams: [],
        estimatedAutomationsCostSaving: 2557,
        estimatedAutomationsTimeSaved: 1080,
        topChangedFiles: [],
        totalAutomationsPerformedCount: 2,
        totalFilesChanged: 0,
        totalAutomationsScheduledCount: 0,
    },
    pendingStepChecklistItemCounts: {
        approvals: 0,
        betaTesting: 4,
        featureReadiness: 4,
        kickoff: 5,
        metadata: 0,
        regressionTesting: 0,
        releaseCandidate: 0,
        screenshots: 0,
        storeReview: 0,
        submission: 4,
        takeoff: 2,
    },
    phasedRelease: null,
    prodBuild: null,
    releaseBranch: 'release-1.2.0',
    releaseBranchCreatedOn: null,
    releaseCommitAfterTagFoundOn: null,
    releaseFAFoundOn: '2023-06-21T19:52:54.521346091Z',
    releaseId: '1.2.0',
    releaseName: null,
    releasePilotId: 'ssullenberger@demo.com',
    releasePlanningSummary:
        'Couple big updates planned for this one: adding a new payment confirmation screen, adding functionality to save multiple items, sharing functionality.',
    releasedAt: null,
    rolloutStartedAt: null,
    runwayOpenedPullRequests: [],
    scheduledAutomationsPaused: null,
    selectedBetaBuild: {
        appStoreBuild: {
            appStoreBuild: {
                buildNumber: '3898',
                id: 'a232fd7a-9c85-4c79-8ff2-b93ec51b9758',
                integrationId: 'apple-beta',
                isProcessed: true,
                type: 'ios-binary',
                uploadedAt: '2023-03-31T09:26:32-07:00',
            },
            associatedCIBuild: null,
            stabilityInfos: {
                'bugsnag:xid': {
                    adoptionPeriodString: null,
                    environmentName: 'development',
                    integrationId: 'bugsnag',

                    sessionAdoption: null,
                    sessionStability: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    url: null,
                    userAdoption: null,
                    userStability: null,
                    version: '1.2.0',
                },
            },
        },
        betaBuildDetails: {
            autoNotifyEnabled: true,
            url: '',
            externalBuildState: 'BETA_APPROVED',
            internalBuildState: 'IN_BETA_TESTING',
            processingState: 'VALID',
        },
        betaGroups: ['6c1c4439-16cb-49e8-b7c4-97d7c1f46a51'],
        betaStatus: 'testing',
        betaTesters: [],
        betaTestingNotes: [
            {
                displayLocale: 'American English',
                id: '31ad4e26-bc75-42c1-8ef9-46558422ab65',
                locale: 'en-US',
                notes: '',
            },
        ],
        buildDistroBuild: null,
        isConsideredExternal: false,
        isLatestBuild: true,
        isSelectedBuild: true,
        selectedReason: 'autoRunwaySelection',
        testTrack: null,
    },
    selectedStagingBuild: null,
    status: 'active',
    stepRunGraph: releaseStepsToStepRunGraph(baseReleaseStepsForPlatform(platform) as any),
    steps: baseReleaseStepsForPlatform(platform),
    lifecycleAutomations: [],
    storeRejectedOn: null,
    submittedAt: null,
    targetKickoffDate: null,
    targetReleaseDate: null,
    targetSubmitDate: null,
    timelinePhase: 'upcoming',
    type: 'minor',
    updatedAt: '0001-01-01T00:00:00Z',
    version: '1.2.0',
    workingBranch: 'development',
    timelineEventsHistory: [
        {
            type: 'release.created',
            triggeredAt: '2023-06-21T19:48:48.686257148Z',
            triggeredBy: 'runway-admin',
            userId: 'dave@runway.team',
            status: 'completed',
            eventData: null,
            orgId: 'appollo-ios',
            appId: 'appollo-ios',
            releaseStepArchetypes: [],
            releaseId: 'appollo-ios:1.2.0',
            releaseData: {
                version: '1.2.0',
                displayableVersion: '1.2.0',
            },
            destinationStepConfigIds: [],
            previouslySeenWithErrorAt: [],
            previouslySeenCount: 0,
        },
        {
            type: 'appStoreVersion.betaSubmittedForReview',
            triggeredAt: '2023-06-08T02:25:14.083232029Z',
            triggeredBy: 'runway',
            userId: null,
            status: 'completed',
            eventData: {
                betaServiceName: 'TestFlight',
                multipleBuildData: [],
            },
            orgId: 'appollo-ios',
            appId: 'appollo-ios',
            releaseStepArchetypes: [],
            releaseId: 'appollo-ios:1.2.0',
            releaseData: {
                version: '1.2.0',
                displayableVersion: '1.2.0',
            },
            destinationStepConfigIds: [],
            previouslySeenWithErrorAt: [],
            previouslySeenCount: 0,
        },
        {
            type: 'release.versionBumped',
            triggeredAt: '2023-03-21T16:16:20.045093835Z',
            triggeredBy: 'runway',
            userId: null,
            status: 'completed',
            eventData: {
                branch: 'development',
                bumpedVersion: '1.2.0',
            },
            orgId: 'appollo-ios',
            appId: 'appollo-ios',
            releaseStepArchetypes: [],
            releaseId: 'appollo-ios:1.2.0',
            releaseData: {
                version: '1.2.0',
                displayableVersion: '1.2.0',
            },
            destinationStepConfigIds: [],
            previouslySeenWithErrorAt: [],
            previouslySeenCount: 0,
        },
    ],
    releaseStatsHistory: [],
    shouldWarnAboutNewerCommits: false,
    shouldMatchPreviousPhasedRelease: false,
    destinationSummaries: [],
});
